enum LocalStorageKeys {
  ACTIVE_SETTINGS_TAB = 'active_settings_tab',
  IS_CALLS_COLUMN_EXPANDED = 'is_calls_column_expanded',
  IS_CONTACTS_COLUMN_EXPANDED = 'is_contacts_column_expanded',
  IS_QUOTES_COLUMN_HIDDEN = 'is_quotes_column_hidden',
  LANGUAGE_INITIALIZED = 'language_initialized',
}

export default LocalStorageKeys;
